export default {
// workflow : {
//     searchWorkitems : '/aaaa'
// },
// fff:{
//     f : 'ff'
// }
};
